// 酒店
const hotelRouter = [
  {
    // 列表页面
    path: '/hotelIndex',
    name: 'hotelIndex',
    component: () => import('@/page/hotel/hotelIndex')
  },
  {
    // 详情页面
    path: '/hotelDetail',
    name: 'hotelDetail',
    component: () => import('@/page/hotel/hotelDetail')
  },
  {
    // 订单填写页面
    path: '/hotelFill',
    name: 'hotelFill',
    component: () => import('@/page/hotel/hotelFill')
  },
  {
    // 订单确认页面
    path: '/hotelConfirm',
    name: 'hotelConfirm',
    component: () => import('@/page/hotel/hotelConfirm')
  },
  {
    // 订单预订成功页面
    path: '/hotelBookSuccess',
    name: 'hotelBookSuccess',
    component: () => import('@/page/hotel/hotelBookSuccess')
  }
]

export default hotelRouter



// WEBPACK FOOTER //
// ./src/router/modules/hotel.js